import { setScrolled } from './../../helpers/events';
import { gsap } from 'gsap';

export default () => {

	const stickyBoxes = document.querySelectorAll('.js-sticky-under-header');
	const header = document.querySelector('.js-header');
	if (!stickyBoxes.length || !header) return;

	let prevScroll = window.pageYOffset;

	stickyBoxes.forEach(box => {

		setScrolled(() => {

			const directionDown = window.pageYOffset > prevScroll;
			const parentTop = box.parentElement.getBoundingClientRect().top;
			const parentBottom = box.parentElement.getBoundingClientRect().bottom;
			const headerHeight = header.offsetHeight;

			if (parentTop < 0 && parentBottom > 0) {

				if (directionDown) {
					gsap.to(box, {
						y: '-100%'
					});
				}

				else {
					gsap.to(box, {
						y: headerHeight
					});
				}

			}

			else {
				gsap.to(box, {
					y: 0
				});
			}

			prevScroll = window.pageYOffset;

		});

	});

}